import React from 'react';
import { UserX } from 'lucide-react';

interface NameBadgeProps {
  isEnglish?: boolean;
}

export const NameBadge: React.FC<NameBadgeProps> = ({ isEnglish }) => (
  <span className="inline-flex items-center gap-1 px-1.5 py-0.5 bg-purple-50 text-purple-700 rounded text-sm font-medium border border-purple-100 print:border-purple-200">
    <UserX className="w-3 h-3" />
    <span>{isEnglish ? 'Redacted' : 'Anônimo'}</span>
  </span>
);